import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './extensions/login/login.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AccessTokenInterceptorService } from './modules/shared/interceptors/access-token-interceptor.service';
import { ErrorHandleInterceptorService } from './modules/shared/interceptors/error-handle-interceptor.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouteReuseStrategy } from '@angular/router';
import { SharedModule } from './modules/shared/shared.module';
import firebase from 'firebase/compat/app';
import 'firebase/compat/database';
import { environment } from 'src/environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FirebaseDatabaseService } from './modules/shared/services/firebase-database/firebase-database.service';
import { ResetPasswordComponent } from './extensions/reset-password/reset-password.component';
import { AwsRedirectionComponent } from './extensions/aws-redirection/aws-redirection.component';
import { AwsRedirectionFailedComponent } from './extensions/aws-redirection-failed/aws-redirection-failed.component';
import { create } from 'd3-selection';
import { SignUpComponent } from './extensions/sign-up/sign-up.component';
import { PrivacyAndPolicyComponent } from './extensions/privacy-and-policy/privacy-and-policy.component';
import { EventsSignUpComponent } from './extensions/events-sign-up/events-sign-up.component';
import { SocialMediaSignUpComponent } from './extensions/social-media-sign-up/social-media-sign-up.component';
import { WhatsappSignUpComponent } from './extensions/whatsapp-sign-up/whatsapp-sign-up.component';
import { QuoteDocumentViewerComponent } from './extensions/document-viewer/quote-document-viewer/quote-document-viewer.component';
import { VoucherDocumentViewerComponent } from './extensions/document-viewer/voucher-document-viewer/voucher-document-viewer.component';
import { LandingLeadPageComponent } from './extensions/landing-lead-page/landing-lead-page.component';
import { InvoiceDocumentViewerComponent } from './extensions/document-viewer/invoice-document-viewer/invoice-document-viewer.component';
import { VisaDocumentsCollectionFormComponent } from './extensions/visa-documents-collection-form/visa-documents-collection-form.component';



firebase.initializeApp(environment.firebaseConfig);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ResetPasswordComponent,
    AwsRedirectionComponent,
    PrivacyAndPolicyComponent,
    SignUpComponent,
    EventsSignUpComponent,
    SocialMediaSignUpComponent,
    WhatsappSignUpComponent,
    AwsRedirectionFailedComponent,
    QuoteDocumentViewerComponent,
    VoucherDocumentViewerComponent,
    InvoiceDocumentViewerComponent,
    LandingLeadPageComponent,
    VisaDocumentsCollectionFormComponent
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    BrowserAnimationsModule
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AccessTokenInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandleInterceptorService,
      multi: true
    },
    FirebaseDatabaseService
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
